(function ($) {
  const initializeBlock = function ($block) {
    function matchHeightFire() {
      $block
        .find(".testimonial-slide .testimonial-slide__quote")
        .matchHeight({ property: "min-height" });
      $block
        .find(".testimonial-slide .testimonial-slide__info")
        .matchHeight({ property: "min-height" });
    }

    matchHeightFire();

    $(window).bind("resize orientationchange", function () {
      matchHeightFire();
    });

    setTimeout(function () {
      matchHeightFire();
    }, 1000);

    const $carousel = $block.find(".testimonials-slider");
    if($carousel.hasClass('slick-initialized'))
      $carousel.slick('unslick');
    $carousel.slick({
      prevArrow: $block.find(".testimonials-slider-arrow--prev"),
      nextArrow: $block.find(".testimonials-slider-arrow--next"),
      arrows: true,
      dots: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      adaptiveHeight: false,
      autoplay: true,
      autoplaySpeed: 7000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            swipe: true,
            adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 7000,
          },
        },
      ],
    });
  };

  $(document).ready(function () {
    $(".block--testimonials-slider").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=testimonials-slider",
      initializeBlock
    );
  }
})(jQuery);
